import axios from 'axios';

import router from '../../router/index'
const BASE_HEADERS = "";
const validStatuses = [200, 201];

//  For Production
const API_URL = 'partner';
//const API_URL = 'http://10.8.1399:8080';  
//const API_URL = 'http://localhost:8080';
//const API_URL = 'http://10.8.139.107:8080';
//const API_URL = 'http://10.8.221.36:8080';
 
const API_CONTENT_URL = 'partner';
const REDIRECT_URL = process.env.VUE_APP_REDIRECT_URL;
axios.interceptors.request.use(function(config) {
    //window.document.getElementById('loader').style.display = "block"
    if(!((new RegExp(/\/bot$/)).test(config.url))){
    EventBus.$emit('showspinner')
    }
    return config;
}, function(err) {
    //window.document.getElementById('loader').style.display = "none"
    EventBus.$emit('hidespinner')
    return Promise.reject(err);
});

axios.interceptors.response.use(function(response) { 
    //window.document.getElementById('loader').style.display = "none" 
    /*if(response.data.errorCode== "401" && response.data.failureMessage == "Unauthorised"){
        window.alert("Session has been expired!. Kindly relogin to continue.")
        return false;
    }*/
    EventBus.$emit('hidespinner')  
    return Promise.resolve(response);
}, function(err) {
    //window.document.getElementById('loader').style.display = "none"
    if (err.response.status == 502 && err.response.config && 
        err.response.config.url && err.response.config.url.indexOf('chatbot') == -1) {
        window.alert('Service is down temporarily or not able to reach server for the moment. Please try again later or contact support.')
    }
    console.log(err.response.status)
    console.log(err.response)
    EventBus.$emit('hidespinner')
    return Promise.reject(err);
});

export class ApiHelper {
    constructor() { }
    // download document
    
    downloadBase64File(contentBase64, fileName) {
        const linkSource = `data:application/pdf;base64,${contentBase64}`;
        const downloadLink = document.createElement('a');
        document.body.appendChild(downloadLink);
    
        downloadLink.href = linkSource;
        downloadLink.target = '_self';
        downloadLink.download = fileName;
        downloadLink.click(); 
        }
    downloadFilebasess(uri, data = {}, type) {
        return axios.get(`${API_URL}` + uri, {
            headers: this.getHeaders(),
            withCredentials: false,
        })
            .then((res) => {
                this.downloadBase64File(res.response,fileName)

            })
            .catch(this.handleError)
    }
    downloadFile(uri, data = {}, type) {
        return axios.get(`${API_URL}` + uri, {
            headers: this.getHeaders(),
            withCredentials: false,
            responseType: 'blob',
        })
            .then((res) => {
                this.checkResponse
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    var blob = new Blob([res.data], { type: 'text/csv/png/xls/pdf/doc/docx/jpg/xlsx' });
                    window.navigator.msSaveOrOpenBlob(blob, res.config.url.split(/_(.+)/)[1]);
                } else {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    var filename = res.config.url.split(/_(.+)/)[1]
                    if(type == 'grievance') {
                        filename='Grievance.xlsx'
                    }
                    link.setAttribute('download', filename); //or any other extensions
                    document.body.appendChild(link);
                    link.click();
                }

            })
            .catch(this.handleError)
    }
    
    downloadGrFile(uri, data, type) {
        return axios.post(`${API_URL}` + uri,data, {
            headers: this.getHeaders(),
            withCredentials: false,
            responseType: 'blob',
        })
            .then((res) => {
                this.checkResponse
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    var blob = new Blob([res.data], { type: 'text/csv/png/xls/pdf/doc/docx/jpg/xlsx' });
                    window.navigator.msSaveOrOpenBlob(blob, res.config.url.split(/_(.+)/)[1]);
                } else {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    var filename = res.config.url.split(/_(.+)/)[1]
                    if(type == 'grievance') {
                        filename='Grievance.xlsx'
                    }
                    link.setAttribute('download', filename); //or any other extensions
                    document.body.appendChild(link);
                    link.click();
                }

            })
            .catch(this.handleError)
    }
    /*
    * Wraps axios and provides
    * more convenient get method
    * calls with data.
    */
    getContent(uri, data = {}) {
        // if (Object.keys(data).length > 0) {
        //   uri = `${uri}?${qs(data)}`
        // }
        return axios.get(`${API_CONTENT_URL}` + uri, {
            headers: this.getHeaders(),
            withCredentials: false
        })
            .then(this.checkResponse)
            .catch(this.handleError)
    }

    /*
    * Wraps axios and provides
    * more convenient get method
    * calls with data.
    */
    get(uri, data = {}) {
        // if (Object.keys(data).length > 0) {
        //   uri = `${uri}?${qs(data)}`
        // }
        return axios.get(`${API_URL}` + uri, {
            headers: this.getHeaders(),
            withCredentials: false
        }, { timeout: 180000 })
            .then(this.checkResponse)
            .catch(this.handleError)
    }

    getImage(uri, data = {}) {
        // if (Object.keys(data).length > 0) {
        //   uri = `${uri}?${qs(data)}`
        // }
        return axios.get(`${API_URL}` + uri, {
            headers: this.getHeaders(),
            withCredentials: false,
            responseType: 'arraybuffer',
        }, { timeout: 180000 })
            .then(this.checkResponse)
            .catch(this.handleError)
    }

    getDashboard(uri, data = {}) {
        // if (Object.keys(data).length > 0) {
        //   uri = `${uri}?${qs(data)}`
        // }
        return axios.get(`${API_URL_Dashboard}` + uri, {
            headers: this.getHeaders(),
            withCredentials: false
        }, { timeout: 180000 })
            .then(this.checkResponse)
            .catch(this.handleError)
    }

    getExternal(url) {
        return axios.get(url).then(this.checkResponse)
            .catch(this.handleError)
    }


    /*
    * Wraps axios and provides
    * more convenient post method
    * calls with payload data
    */
    post(uri, data) {
        return axios.post(`${API_URL}` + uri, data, {
            headers: this.getHeaders(),
            withCredentials: false
        }).then(this.checkResponse)
            .catch(this.handleError)
    }

    postDashboard(uri, data) {
        return axios.post(`${API_URL_Dashboard}` + uri, data, {
            headers: this.getHeaders(),
            withCredentials: false
        }).then(this.checkResponse)
            .catch(this.handleError)
    }

    postFile(uri, formData) {
        return axios.post(`${API_URL}` + uri, formData, {
            headers: this.getHeaders(true),
            withCredentials: false
        }).then(this.checkResponse)
            .catch(this.handleError)
    }

    /*
     * Wraps axios and provides
     * more convenient put method
     * calls with data
     */
    put(uri, data) {
        return axios.put(`${API_URL}` + uri, data, {
            headers: this.getHeaders(),
            withCredentials: false
        }).then(this.checkResponse)
            .catch(this.handleError)
    }

    /*
     * Wraps axios and provides
     * more convenient delete method
     */
    remove(uri, data) {
        return axios.delete(`${API_URL}` + uri, {
            headers: this.getHeaders(),
            withCredentials: false, data: data
        }).then(this.checkResponse)
            .catch(this.handleError)
    }

    /*
    * Wraps axios and provides
    * more convenient post method
    * calls with payload data
    */
    //    TO GENRATE TOKEN 
    login(uri, data) {
        return axios.post(`${API_URL}` + uri, data, {
            headers: this.getHeaders(),
            withCredentials: false
        }).then(response => {
            sessionStorage.setItem('token', response.data.accessToken ? response.data.accessToken : '');
            return response.data;
        }).catch(this.handleError)
    }

    summaryLogin(uri, data) {
        return axios.post(`${API_URL}` + uri, data, {
            headers: this.getHeaders(),
            withCredentials: false
        }).then(response => {
            sessionStorage.setItem('token', response.data.response.accessToken);
            return response.data;
        }).catch(this.handleError)
    }

    logout(uri) {
        // store.commit('setToken', '');
        return axios.post(`${API_URL}` + uri, {}, {
            headers: this.getHeaders(),
            withCredentials: false
        }).then(response => {
            sessionStorage.removeItem('token');
            window.location.href = `${LOGOUT_URL}`;
        }).catch(this.handleError);
    }

    /*
    * Returns default headers list
    * which will be used with every request.
    */
    getHeaders(multipart = false) {
        let defaultHeaders = BASE_HEADERS
        if (multipart) {
            defaultHeaders = {}
        }
        if (sessionStorage.getItem('token')) {
            defaultHeaders = {
                'Authorization': "Bearer " + sessionStorage.getItem('token'),
                ...defaultHeaders
            }
        }
        return defaultHeaders
    }

    /*
    * Wraps error responses from the API
    * and returns `Promise.reject` with error
    */
    checkResponse(response) {
        if(response && response.data && response.data.errorMsg && response.data.errorMsg == 'Sharepoint service is down temporarily')
        {
            window.alert(response.data.errorMsg)
        }
        if (validStatuses.includes(response.status)) {
            return response.data
        }
        // If not authorized then reset token
        // and redirect to login page
        if (response.data.errorCode == 401) {
            sessionStorage.removeItem('token');
            window.location.href = `${REDIRECT_URL}`;
            return Promise.reject(new Error('USER_ANONYMOUS'))
        } else {
            store.commit('showApiError', true);
            let err = new Error(response.statusText)
            err.response = response
            return Promise.reject(err)
        }
    }

    handleError(error) {
        if (error.response && error.response.status) {
            switch (error.response.status) {
                case 401:
                    // for Summary
                    // sessionStorage.clear();
                    // alert("Session Expired")
                    // window.reload();
                    // sessionStorage.removeItem('token');
                    // window.location.href = `${REDIRECT_URL}`;
                    // return error.response;
                    // return Promise.reject(new Error('USER_ANONYMOUS'))
                    return Promise.reject(error.response.data);
                case 400:
                    // window.location.href = `${REDIRECT_URL}`
                    // sessionStorage.removeItem('token');
                    return Promise.reject(error.response.data);
                // return error.response.data
                case 404:
                    return Promise.reject(error.response.data);
                case 440:
                    // alert("Session Expired")
                    sessionStorage.clear();
                    //   if (
                    //     this.$route.name == "PartnerApproval" ||
                    //   this.$route.name == "Summary"
                    // ) {
                    //   location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
                    //  } else {
                    router.push({
                        name: "Login",
                        params: {
                            sourceFrom: "ShowValidationMessage"
                        }
                    })
                    //}
                    return Promise.reject(error.response.data);
                case 403:
                    // alert("Session Expired")
                    // sessionStorage.clear();
                    return Promise.reject(error.response.data);
                default:
                    // store.commit('showApiError', true);
                    let err = new Error(error.response);
                    return Promise.reject(err);
            }
        } else {
            // store.commit('showApiError', true);
            let err = new Error(error.response.data);
            return Promise.reject(err)
        }
    }
}